import { createFileRoute } from '@tanstack/react-router';
import { hasPermission } from '@atnt/shared';
import { dashboardQuery, sectionsQuery, sensorsQuery } from '@/features/constructor/api';
import { DashboardEditorPage } from '@/features/dashboard-editor/DashboardEditorPage';

/** "Bosh panel" editor — "Dashboard sozlamasi" (constructor, 317:6923). Requires monitoring `dashboard.edit`. */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/dashboard/edit')({
  loader: ({ context }) => {
    // warm the cache only for editors; the page renders its own loading / no-access states
    if (!hasPermission(context.tenant.permissions, { panel: 'monitoring', menu: 'dashboard', action: 'edit' })) return;
    void context.queryClient.prefetchQuery(dashboardQuery(context.tenant.id));
    void context.queryClient.prefetchQuery(sectionsQuery(context.tenant.id));
    void context.queryClient.prefetchQuery(sensorsQuery(context.tenant.id));
  },
  component: DashboardEditRoute,
});

function DashboardEditRoute() {
  const { tenant } = Route.useRouteContext();
  return <DashboardEditorPage tenant={tenant} />;
}
